import request from '@/axios/http'

// 开奖数据更新 - 彩种与格式能力列表
// GET /stage-api/dataupdate/products
// 返回：{ code, data: [ { preType, preName, formatCodes:[{code,desc}], zoneSplittable, phases:[AFTER/BEFORE] } ] }
export function getProducts() {
  return request({
    url: '/stage-api/dataupdate/products',
    method: 'get'
  })
}

// 我的订阅状态（免费版剩余次数 / 标准版到期）
// GET /stage-api/dataupdate/subscription
// 返回：{ code, data: { plan, planName, standard, startTime, endTime, remaining, monthLimit, monthUsed } }
export function getSubscription() {
  return request({
    url: '/stage-api/dataupdate/subscription',
    method: 'get'
  })
}

// 生成更新记录（仅处理并落库一条记录，不立即下载）
// POST /stage-api/dataupdate/generate
// Body: { preType, formatCode, zone(ALL/FRONT/BACK), phase(AFTER/BEFORE), periodFrom, periodTo, fileId }
// 返回：{ code, data: { id, preType, formatDesc, periodFrom, periodTo, recordCount, status, msg, createTime } }
// 下载请用 downloadLog(id)
export function generateData(data) {
  return request({
    url: '/stage-api/dataupdate/generate',
    method: 'post',
    data,
    timeout: -1
  })
}

// 按更新记录ID下载处理好的开奖数据 txt（文件流，responseType: blob）
// GET /stage-api/dataupdate/log/{id}/download
// 不产生新记录、不扣配额；返回二进制 txt（Content-Disposition 含文件名）
export function downloadLog(id) {
  return request({
    url: '/stage-api/dataupdate/log/' + id + '/download',
    method: 'get',
    responseType: 'blob',
    timeout: -1
  })
}

// 我的更新日志（最近 100 条）
// GET /stage-api/dataupdate/log/list
export function getLogList(params) {
  return request({
    url: '/stage-api/dataupdate/log/list',
    method: 'get',
    params: {
      ...(params || {}),
      pageNum: params && params.pageNum !== undefined ? Number(params.pageNum) : 1,
      pageSize: params && params.pageSize !== undefined ? Number(params.pageSize) : 20
    }
  })
}

// 购买会员（月付 9.9 元 / 年付 68 元），返回订单信息拉起支付
// POST /stage-api/dataupdate/subscribe
// Body: { plan: 'MONTH'(月) | 'YEAR'(年), payType: balancepay/wxpay/alipay }
// 返回：{ code, data: { orderNo, title, money, payType, codeUrl(微信/支付宝支付二维码链接) } }
export function subscribe(data) {
  return request({
    url: '/stage-api/dataupdate/subscribe',
    method: 'post',
    data
  })
}

// 购买单次转换额度（2 元/次，不限期数），返回订单信息拉起支付
// POST /stage-api/dataupdate/buySingle
// Body: { payType: balancepay/wxpay/alipay, returnUrl?, notifyUrl? }
// 返回结构与 subscribe 一致（DataUpdateOrderVO）
export function buySingle(data) {
  return request({
    url: '/stage-api/dataupdate/buySingle',
    method: 'post',
    data
  })
}

// 查询订单支付状态（微信/支付宝扫码后前端轮询用）
// GET /stage-api/order/checkOrder/{orderNo}（统一查询订单状态，校验当前登录用户）
// 返回：{ code, data: '0'待支付 | '1'已支付 | '2'已取消 | '3'超时关闭 }
export function checkOrder(orderNo) {
  return request({
    url: '/stage-api/order/checkOrder/' + orderNo,
    method: 'get'
  })
}

// 我的购买记录（最近 20 条订单流水）
// GET /stage-api/dataupdate/my/orders
// 返回：{ code, data: [ { orderNo, title, money, payType, status('0'待/'1'已支付/'2'取消/'3'关闭), createTime } ] }
export function getMyOrders() {
  return request({
    url: '/stage-api/dataupdate/my/orders',
    method: 'get'
  })
}

// 价格与规则说明（会员月/年价、单次价、免费额度、免责声明）
// GET /stage-api/dataupdate/price
// 返回：{ code, data: { monthPrice, yearPrice, singlePrice, freeFileMonthLimit, fileFreeBatchMax, disclaimer } }
export function getPrice() {
  return request({
    url: '/stage-api/dataupdate/price',
    method: 'get'
  })
}

// 上传我的软件数据文件（识别格式与最新期后存储，供后续追加更新）
// POST /stage-api/dataupdate/upload  (multipart/form-data)
// 字段：file(文件≤2MB)、preType(彩种)、format(可选，自动识别失败时手动指定 DYJ_1~5/COLON/XY500)
export function uploadMyFile(formData) {
  return request({
    url: '/stage-api/dataupdate/upload',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 我的上传文件列表（最近 50 个）
// 返回：{ code, data: [ { id, preType, preName, formatCode, formatDesc, fileName, lineCount, lastPeriod, createTime } ] }
export function getMyFiles() {
  return request({
    url: '/stage-api/dataupdate/my/files',
    method: 'get'
  })
}

// 删除我的上传文件
// DELETE /stage-api/dataupdate/my/file/{id}
export function deleteMyFile(id) {
  return request({
    url: '/stage-api/dataupdate/my/file/' + id,
    method: 'delete'
  })
}

// 查看上传文件解析出的开奖号明细
// GET /stage-api/dataupdate/my/file/{id}/detail
// 返回：{ code, data: { id, preType, preName, formatCode, formatDesc, fileName, lineCount,
//   lastPeriod, createTime, hasPeriodRows, rows:[{period, openNbr, saleMoney}], rawLines:[...] } }
export function getMyFileDetail(id) {
  return request({
    url: '/stage-api/dataupdate/my/file/' + id + '/detail',
    method: 'get'
  })
}
